<template>
  <v-textarea
    :rules="rules"
    v-bind="fieldProps"
    no-resize
    name="message"
    label="Mensagem"
  ></v-textarea>
</template>

<script>
import { requiredValidation } from "../validations/requiredValidation";
import { mixin } from "./mixin";

export default {
  data: () => ({
    rules: [requiredValidation("Digite a mensagem.")],
  }),
  mixins: [mixin],
};
</script>
